var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAddText = function SvgAddText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#393F4F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8 7c0-.4-.3-.8-.8-.8h-7.8c-3.3 0-6 2.6-6 5.7v4c0 .4.3.8.8.8s.8-.3.8-.8v-4c0-2.3 2-4.2 4.5-4.2H20c.4.1.8-.3.8-.7zM37 50.2h-5.2V7.8h17.8c2.6 0 4.7 1.9 4.7 4.2v4c0 .4.3.8.8.8s.8-.3.8-.8v-4c0-3.1-2.8-5.7-6.2-5.7H31c-.4 0-.8.3-.8.8v43.2H20c-.4 0-.8.3-.8.8s.3.8.8.8h17c.4 0 .8-.3.8-.8s-.4-.9-.8-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2 28.3H40c-.4 0-.8.3-.8.8s.3.8.8.8h20.2c1.7 0 3.1 1.3 3.1 3V35c0 .4.3.8.8.8s.8-.3.8-.8v-2.3c-.1-2.4-2.2-4.4-4.7-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 59.2h-5.3c0-.1.1-.2.1-.2V31c0-.4-.3-.8-.8-.8s-.8.3-.8.8v28c0 .1 0 .2.1.2H40c-.4 0-.8.3-.8.8s.3.8.8.8h13c.4 0 .8-.3.8-.8s-.4-.8-.8-.8z"
  }))));
};
export default SvgAddText;